import { createdATFilter, getVisibleFilter, mainPhoneFilter } from 'modules/common/constants/filters/common.filters';
import { addressFilters } from 'lib/dfl-address-filter/filters';
import { commissionFilter } from '../../supplier/constants';

const visibleFilter = getVisibleFilter('visible');

const logisticAddressFilter = addressFilters({
  countryFilter: 'warehouse:address.country',
  countryKey: 'country',
  countryField: 'address.country',
  stateFilter: 'warehouse:address.state',
  stateKey: 'state',
  stateField: 'address.state',
  cityFilter: 'warehouse:address.city',
  cityKey: 'city',
  cityField: 'address.city',
});

export const logisticFilters = [
  mainPhoneFilter,
  commissionFilter,
  ...logisticAddressFilter,
  visibleFilter,
  createdATFilter,
];
